/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Blank_Empty_BodyInputs */

const en_us2_workout_blank_empty_body = /** @type {(inputs: Workout_Blank_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You build the workout as you go, one exercise at a time. Your plan does not change.`)
};

const pt_br2_workout_blank_empty_body = /** @type {(inputs: Workout_Blank_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você monta o treino na hora, um exercício de cada vez. O seu plano não muda.`)
};

const es_419_workout_blank_empty_body = /** @type {(inputs: Workout_Blank_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armas el entrenamiento sobre la marcha, un ejercicio a la vez. Tu plan no cambia.`)
};

const pt_pt2_workout_blank_empty_body = /** @type {(inputs: Workout_Blank_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montas o treino na hora, um exercício de cada vez. O teu plano não muda.`)
};

const fr_fr2_workout_blank_empty_body = /** @type {(inputs: Workout_Blank_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu construis la séance au fur et à mesure, un exercice à la fois. Ton programme ne change pas.`)
};

const de_de2_workout_blank_empty_body = /** @type {(inputs: Workout_Blank_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du baust das Training unterwegs auf, eine Übung nach der anderen. Dein Plan ändert sich nicht.`)
};

const it_it2_workout_blank_empty_body = /** @type {(inputs: Workout_Blank_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costruisci l'allenamento strada facendo, un esercizio alla volta. La tua scheda non cambia.`)
};

/**
* | output |
* | --- |
* | "You build the workout as you go, one exercise at a time. Your plan does not change." |
*
* @param {Workout_Blank_Empty_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_blank_empty_body = /** @type {((inputs?: Workout_Blank_Empty_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Blank_Empty_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_blank_empty_body(inputs)
	if (locale === "es-419") return es_419_workout_blank_empty_body(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_blank_empty_body(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_blank_empty_body(inputs)
	if (locale === "de-DE") return de_de2_workout_blank_empty_body(inputs)
	if (locale === "it-IT") return it_it2_workout_blank_empty_body(inputs)
	return en_us2_workout_blank_empty_body(inputs)
});
export { workout_blank_empty_body as "workout.blank_empty_body" }